export enum StatusFilterType {
    ALL_SELECTED = "all_selected",
    ANY_SELECTED = "any_selected",
    EXCLUDE_SELECTED = "exclude_selected",
}

export interface StatusFilter<TStatus extends string> {
    filterType: StatusFilterType;
    kickStatuses: TStatus[];
    externalStatuses: TStatus[];
}
